import { useCallback, useContext } from 'react'

import { type SanityFrameBuilderType } from '@frame-builder/data/sanity/queries/types'
import { FrameBuilderCommittedStateContext } from '@frame-builder/contexts/state-context'
import { LanguageContext } from '@lib/language-context'
import { createFrameBuilderProduct } from './request'

/**
 * Returns a hook that creates frame builder product in Shopify.
 */
export const useCreateFrameBuilderProduct = (
  frameBuilderType: SanityFrameBuilderType,
  getProductImageDataUrl: () => string | undefined,
  setIsCreatingProduct: (isCreatingProduct: boolean) => void,
) => {
  const { committedState } = useContext(FrameBuilderCommittedStateContext)
  const { locale } = useContext(LanguageContext)

  return useCallback(async () => {
    try {
      // Get product image
      const productImageDataUrl = getProductImageDataUrl()

      if (!productImageDataUrl) {
        throw new Error('Failed to generate product image')
      }

      // Create frame builder product
      setIsCreatingProduct(true)

      const createFrameBuilderProductResponse = await createFrameBuilderProduct(
        locale,
        frameBuilderType,
        committedState,
        productImageDataUrl,
      )

      setIsCreatingProduct(false)

      return createFrameBuilderProductResponse
    } catch (error) {
      console.error(error)

      setIsCreatingProduct(false)

      throw new Error('Product creation failed')
    }
  }, [
    committedState,
    frameBuilderType,
    getProductImageDataUrl,
    locale,
    setIsCreatingProduct,
  ])
}
